"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { ModelsModelCard } from "@/components/models.model-card";
import { ModelsPricingTable } from "@/components/models.pricing-table";
import { useSession } from "@/lib/auth";
import { RADIUM_SHOWCASE_MODELS } from "@/lib/models-showcase";

const ModelsPage = () => {
  const { data: session, isPending } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (!isPending && !session?.user) {
      router.push("/login");
    }
  }, [session?.user, isPending, router]);

  if (isPending) {
    return <div className="flex min-h-screen items-center justify-center">Loading...</div>;
  }

  if (!session?.user) {
    return null;
  }

  return (
    <div className="@container/main flex flex-1 flex-col gap-2">
      <div className="flex flex-col gap-4 md:gap-6">
        <div>
          <div>
            <h1 className="text-3xl font-bold">Models</h1>
            <p className="text-muted-foreground">
              Compare Radium&apos;s AI models — choose the right balance of capability, speed, and cost for your
              workload.
            </p>
          </div>
        </div>

        <div>
          <div className="flex flex-col gap-8">
            <ModelsPricingTable models={RADIUM_SHOWCASE_MODELS} />
            <div>
              <h2 className="mb-[length:var(--ds-space-4)] text-[length:var(--ds-type-size-lg)] font-semibold tracking-[length:var(--ds-type-tracking-tight)] text-foreground">
                Model Details
              </h2>
              <div className="grid items-stretch gap-[length:var(--ds-space-5)] md:grid-cols-2 xl:grid-cols-3">
                {RADIUM_SHOWCASE_MODELS.map((m) => (
                  <ModelsModelCard key={m.id} model={m} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModelsPage;
